import { invoke } from '@shared/easyfy.decorators';
import { Filter } from '@clientWebModules/filter';
import { FilterFor } from '@clientShared/filter.types';
import ToggleCss from '@shared/easyfy.togglecss';
import ScrollTo from '@shared/easyfy.scrollto';
import '@clientWebModules/sorter';

@invoke
export default class Search {
  constructor() {
    void new ToggleCss('togglecss');
    void new ScrollTo('smooth', true);
  }

  onInit() {
    void new Filter(
      FilterFor.Search,
      '[data-container="filter"]',
      '[data-container="paging"]',
      '[data-static-products]',
      '[data-container="sorter"]',
      '[data-container="selected-filters"]',
      true
    );
  }
}
